import { getAPIBaseURL } from './helpers'
import { getData, postData, updateData, deleteData } from './request'

const base = () => `${getAPIBaseURL()}/v1`

const getAuthHeaders = () => {
  const token = localStorage.getItem('token')
  console.log('token', token)
  return token ? { 'token': token } : {}
}

export const listEvents = async (params = {}) => {
  const url = `${base()}/events`
  const headers = {
    ...getAuthHeaders(),
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  const res = await getData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const getEvent = async (eventId) => {
  const url = `${base()}/events/${eventId}`
  const headers = {
    ...getAuthHeaders(),
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const createEvent = async (payload) => {
  const url = `${base()}/events`
  const headers = {
    ...getAuthHeaders(),
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  const res = await postData(url, headers, payload)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message || 'Failed to create event' }
}

export const updateEvent = async (eventId, payload) => {
  const url = `${base()}/events`
  const headers = {
    ...getAuthHeaders(),
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  // payload is already a URLSearchParams string, just append eventId
  const params = new URLSearchParams(payload)
  params.append('eventId', eventId)
  const res = await updateData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message || 'Failed to update event' }
}

export const deleteEvent = async (eventId) => {
  const url = `${base()}/events/${eventId}`
  const headers = getAuthHeaders()
  const res = await deleteData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message || 'Failed to delete event' }
}

export const listAdminEvents = async (params = {}) => {
  const url = `${base()}/admin/events`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

